/* eslint-disable jira/integration/test-id-by-folder-structure */
import React, { useEffect } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import FullscreenButton from '@atlassian/jira-fullscreen-button/src/index.tsx';
import { useIsFullscreen } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/fullscreen/index.tsx';
import { addRouteListener } from '@atlassian/react-resource-router/src/controllers/router-store/index.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

// These routes will show the global fullscreen button, others won't
export const SUPPORTED_ROUTES: RouteName[] = [
	'software-boards',
	'software-timeline-classic',
	'rapidboard-backlog',
	'rapidboard-board',
	'rapidboard-user-board',
	'software-backlog',
	'software-timeline',
	'classic-business-timeline',
	'classic-business-board',
	'connect-project',
	'connect-general',
	'forge-spa-project',
	'forge-spa-global',
];

export const HeaderFullscreenButton = () => {
	const [isFullscreen, { setIsFullscreen }] = useIsFullscreen();

	useEffect(() => {
		const unsubscribe = addRouteListener((state) => {
			// The board settings page is /jira/software/c/projects/TEST/boards/81/?config=filter
			// which matches the RAPIDBOARD_BOARD route, but we want to exclude it from fullscreen
			const isOnBoardConfig = state.route.name === 'rapidboard-board' && !!state.query.config;

			if ((isFullscreen && !SUPPORTED_ROUTES.includes(state.route.name)) || isOnBoardConfig) {
				setIsFullscreen(false);
			}
		});
		return () => unsubscribe();
	}, [isFullscreen, setIsFullscreen]);

	return (
		<JSErrorBoundary
			fallback="unmount"
			id="jira-horizontal-nav-header-fullscreen-button"
			packageName="jira-horizontal-nav-header"
			teamName="Jira Cosmos"
		>
			<FullscreenButton
				key="fullscreen"
				data-vc="horizontal-nav-header-fullscreen-button"
				testId="horizontal-nav-header.ui.fullscreen-button.fullscreen-button"
				withContainerStyles={false}
			/>
		</JSErrorBoundary>
	);
};
